import React from "react";
import "./Consultoria.css";
import TarjetaDeServicioConsultoria from "./components/TarjetaDeServicioConsultoria";
import GestionConsultoria from "./components/GestionConsultoria";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function Consultoria() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.consultoria.services.0.title"),
      desc: t("pages.consultoria.services.0.desc"),
    },
    {
      title: t("pages.consultoria.services.1.title"),
      desc: t("pages.consultoria.services.1.desc"),
    },
    {
      title: t("pages.consultoria.services.2.title"),
      desc: t("pages.consultoria.services.2.desc"),
    },
    {
      title: t("pages.consultoria.services.3.title"),
      desc: t("pages.consultoria.services.3.desc"),
    },
  ];

  return (
    <>
      <section
        className="fondo-consultoria"
        style={
          {
            backgroundImage: 'url("/Consultoriaaa.webp")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          } as React.CSSProperties
        }
      >
        <div className="consultoria-overlay">
          <h1 className="consultoria-titulo">{t("pages.consultoria.title")}</h1>
          <p className="consultoria-descripcion">
            {t("pages.consultoria.description")}
          </p>
        </div>
      </section>

      <h2 className="consultoria-subtitulo">
        {t("pages.consultoria.benefits_title")}
      </h2>
      <div className="consultoria-card-grid">
        {services.map((service, index) => {
          let animationClass = "from-bottom";
          if (index === 0) animationClass = "from-left";
          else if (index === 1) animationClass = "from-bottom";
          else if (index === 2) animationClass = "from-right";
          else if (index === 3) animationClass = "from-left";

          return (
            <TarjetaDeServicioConsultoria
              key={index}
              service={service}
              delay={index * 0.15}
              animationClass={animationClass}
            />
          );
        })}
      </div>

      <GestionConsultoria
        alcance={[
          { titulo: t("pages.consultoria.alcance.0.titulo") },
          { titulo: t("pages.consultoria.alcance.1.titulo") },
          { titulo: t("pages.consultoria.alcance.2.titulo") },
          { titulo: t("pages.consultoria.alcance.3.titulo") },
        ]}
      />
    </>
  );
}
